import { Component, OnInit, Input, OnChanges, SimpleChanges  } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { isEmptyField } from '../../vl_util_functions/common-utils';
@Component({
  selector: 'vl-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {
  @Input()
  id!: string;
  @Input()
  show!: boolean;
  
  constructor(private spinnerService: NgxUiLoaderService) { }
  
  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges){
    if  (isEmptyField(this.id)) {
      return;
    }
    (changes['show'] && changes['show'].currentValue)?this.startLoader():this.stopLoader();
  }

  startLoader(): void{
    this.spinnerService.startLoader(this.id);
  }

  stopLoader(): void{
    try{
      this.spinnerService.stopLoader(this.id)
    }catch(e){
    }
  }
  
  makeid(length: number) {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }
}
